// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import { fetchImportLogEvents } from 'syft-acp-core/api'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('IMPORT_EVENT_LOGS_FETCH', fetchImportLogEvents)
}
